export default "__VITE_ASSET__CTHPxDeS__"